module.exports = __webpack_public_path__ + "img/magento-modules-customization@2x.7fa89ff4.webp";